import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Hero } from '../components/home/Hero';
import { TrustCounters } from '../components/home/TrustCounters';
import { TrustedBy } from '../components/home/TrustedBy';
import { AboutSection } from '../components/home/AboutSection';
import { MotiveSection } from '../components/home/MotiveSection';
import { WhyChoose } from '../components/home/WhyChoose';
import { IntelligentSolutions } from '../components/home/IntelligentSolutions';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { ProcessFlow } from '../components/home/ProcessFlow';
import { IndustriesSection } from '../components/home/IndustriesSection';
import { IndiaMap } from '../components/home/IndiaMap';
import { Testimonials } from '../components/home/Testimonials';
import { FAQSection } from '../components/home/FAQSection';
import { ContactSection } from '../components/home/ContactSection';
import { CTABand } from '../components/CTABand';
import { useSEO } from '../hooks/useSEO';

export default function Home() {
  useSEO(
    'WorkLynx — India\u2019s Workforce & Operations Partner for Scale',
    'Workforce deployment, AI data collection, robotics operations, IT & Non-IT hiring, BPO and managed workforce services across 15+ Indian cities.'
  );

  return (
    <Layout>
      <Hero />
      <TrustCounters />
      <TrustedBy />
      <AboutSection />
      <MotiveSection />
      <WhyChoose />
      <IntelligentSolutions />
      <ServicesGrid />
      <CTABand title="Not Sure Which Service Fits?" subtitle="Talk to our solutions team — we'll map your requirement to the right engagement model, free of charge." />
      <ProcessFlow />
      <IndustriesSection />
      <IndiaMap />
      <Testimonials />
      <FAQSection />
      <CTABand />
      <ContactSection />
    </Layout>
  );
}
